import React, { useEffect } from "react";
import { Star } from "lucide-react";

const SF_SRC = "https://b.sf-syn.com/badge_js?sf_id=4117248&variant_id=sf";

// Review-platform listings. Flip `enabled` to true (and add the href) as each listing goes live.
const PLATFORMS = [
  { key: "trustradius", name: "TrustRadius", href: "https://www.trustradius.com/products/tradeoff", color: "#127C71", enabled: true },
  { key: "trustpilot", name: "Trustpilot", href: "", color: "#00B67A", enabled: false },
  { key: "capterra", name: "Capterra", href: "https://www.capterra.com/p/10053460/TradeOff/", color: "#FF9D28", enabled: true },
  { key: "g2", name: "G2", href: "", color: "#FF492C", enabled: false },
];

// Reusable social-proof bar: SourceForge official badge + review-platform listing links.
const ReviewBadges = ({ className = "" }) => {
  useEffect(() => {
    // (Re)inject the SourceForge badge script so it renders every .sf-root on the page,
    // including after client-side route changes.
    const prev = document.getElementById("sf-badge-script");
    if (prev) prev.remove();
    const sc = document.createElement("script");
    sc.id = "sf-badge-script";
    sc.async = true;
    sc.src = SF_SRC;
    document.body.appendChild(sc);
  }, []);

  const platforms = PLATFORMS.filter((p) => p.enabled && p.href);

  return (
    <div className={`flex flex-wrap items-center justify-center gap-x-5 gap-y-4 ${className}`} data-testid="review-badges">
      {/* SourceForge official rating badge */}
      <div
        className="sf-root shrink-0"
        data-id="4117248"
        data-badge="customers-love-us-white"
        data-variant-id="sf"
        style={{ width: 125 }}
      >
        <a href="https://sourceforge.net/software/product/TradeOff/" target="_blank" rel="noopener noreferrer">
          TradeOff Reviews
        </a>
      </div>

      {/* Other review-platform listings (logo-style wordmark links until an official rating widget is available) */}
      {platforms.map((p) => (
        <a
          key={p.key}
          href={p.href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`review-badge-${p.key}`}
          className="group inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-4 py-2 text-sm font-semibold text-slate-200 transition-colors hover:bg-white/10 hover:border-white/40"
        >
          <Star className="h-4 w-4 fill-current" style={{ color: p.color }} />
          <span className="tracking-tight group-hover:text-white">{p.name}</span>
        </a>
      ))}
    </div>
  );
};

export default ReviewBadges;
